import { Inject, Injectable, Optional } from '@angular/core';
import { Observable, of, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { PharmacyEscriptDescriptor } from './pharmacy-escript.descriptor';
import { PHARMACY_ESCRIPT_DESCRIPTORS } from './pharmacy-escript.tokens';
import { ClinicalPharmacyService } from './clinical-pharmacy.service';

/** Lookups over the registered vendor descriptors. */
@Injectable({ providedIn: 'root' })
export class PharmacyEscriptRegistryService {
  private readonly descriptors: PharmacyEscriptDescriptor[];

  constructor(
    @Optional() @Inject(PHARMACY_ESCRIPT_DESCRIPTORS) descriptors: PharmacyEscriptDescriptor[] | null,
    private clinicalPharmacy: ClinicalPharmacyService
  ) {
    this.descriptors = descriptors ?? [];
  }

  all(): PharmacyEscriptDescriptor[] {
    return this.descriptors;
  }

  byId(id: string): PharmacyEscriptDescriptor | undefined {
    return this.descriptors.find(d => d.id === id);
  }

  /** Descriptors enabled for the current provider AND not globally kill-switched (both live). */
  allowed$(): Observable<PharmacyEscriptDescriptor[]> {
    if (!this.descriptors.length) {
      return of([]);
    }
    return combineLatest([combineLatest(this.descriptors.map(d => d.allowed$())), this.clinicalPharmacy.disabledVendors$()]).pipe(
      map(([flags, disabled]) => this.descriptors.filter((d, i) => flags[i] && !disabled[d.id]))
    );
  }
}
